import React, { useEffect, useState } from 'react'
import "./horizontalProductcard.css"
import { Rate } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { FaMinus, FaPlus, FaShoppingCart } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { IoMdArrowDropdown } from 'react-icons/io';
import QuickViewModal from './QuickViewModal';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as newApi from "../../api/apiCollection"
import { toast } from 'react-toastify';
import { addGuestCartTotal, addtoGuestCart, setCart, setCartProducts, setCartSubTotal, subGuestCartTotal } from '../../model/reducer/cartReducer';
import ProductVariantModal from './ProductVariantModal';
import ImageWithPlaceholder from '../image-with-placeholder/ImageWithPlaceholder';
import { BiHeart, BiSolidHeart } from 'react-icons/bi';
import { addFavoriteProductId } from '../../model/reducer/favouriteReducer';
import VegIcon from "../../utils/Icons/VegIcon.svg";
import NonVegIcon from "../../utils/Icons/NonVegIcon.svg";

const HorizonalProduct = ({ product }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const setting = useSelector(state => (state.setting));
    const cart = useSelector(state => (state.cart))
    const user = useSelector(state => (state.user))
    const favoriteProducts = useSelector(state => (state.favourite))

    const [p_id, setP_id] = useState(0);
    const [p_v_id, setP_V_id] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setselectedProduct] = useState({});
    const [selectedVariant, setSelectedVariant] = useState()
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [showVariantModal, setShowVariantModal] = useState(false)
    const [discountCountdown, setDiscountCountdown] = useState(null);

    useEffect(() => {
        const inStockVariant = product?.variants?.find((variant) => variant?.is_unlimited_stock === 0 && variant?.stock > 0)
        const selected = inStockVariant ?? product?.variants[0];
        setSelectedVariant(selected);

        // Set default color and size if available
        if (selected && isClothingProduct(selected)) {
            const colors = getVariantColors(selected);
            const sizes = getVariantSizes(selected);
            
            if (colors.length > 0) {
                setSelectedColor(colors[0]);
            }
            
            if (sizes.length > 0) {
                setSelectedSize(sizes[0]);
            }
        }
    }, [product])

    // دالة منفصلة لإعداد عداد الخصم
    useEffect(() => {
        if (!selectedVariant) return;
        
        // إعداد عداد الخصم
        if (selectedVariant?.discounted_price && selectedVariant?.discounted_price < selectedVariant?.price) {
            const now = new Date();
            let startDate, endDate;
            
            try {
                startDate = new Date(selectedVariant.discount_start_date);
                endDate = new Date(selectedVariant.discount_end_date);
            } catch (error) {
                setDiscountCountdown(null);
                return;
            }

            if (now >= startDate && now <= endDate) {
                const interval = setInterval(() => {
                    const remaining = endDate - new Date();
                    if (remaining <= 0) {
                        clearInterval(interval);
                        setDiscountCountdown(null);
                    } else {
                        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
                        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
                        const seconds = Math.floor((remaining / 1000) % 60);
                        const countdownText = `${days} يوم ${hours} ساعة ${minutes} دقيقة ${seconds} ثانية`;
                        setDiscountCountdown(countdownText);
                    }
                }, 1000);

                return () => clearInterval(interval);
            } else {
                setDiscountCountdown(null);
            }
        } else {
            setDiscountCountdown(null);
        }
    }, [selectedVariant])

    // تعديل البحث عن المنتج في السلة ليشمل اللون والمقاس
    const isProductAlreadyAdded = (
        (cart?.isGuest === false && 
            cart?.cartProducts?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0) ||
        (cart?.isGuest === true && 
            cart?.guestCart?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0)
    );

    const addedQuantity = cart?.isGuest === false
        ? cart?.cartProducts?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0
        : cart?.guestCart?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0;

    // تعديل منطق الإضافة للسلة ليضيف منتج جديد إذا لم يوجد مطابق بنفس اللون والمقاس
    const addToCart = async (productId, productVId, qty) => {
        try {
            const response = await newApi.addToCart({ 
                product_id: productId, 
                product_variant_id: productVId, 
                qty: qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            });
            
            if (response.status === 1) {
                const existingProduct = cart?.cartProducts?.find((product) => 
                    product?.product_id == productId && 
                    product?.product_variant_id == productVId &&
                    product?.selected_color === selectedColor &&
                    product?.selected_size === selectedSize
                );
                
                if (!existingProduct?.qty) {
                    // Add new product to cart
                    dispatch(setCart({ data: response }));
                    const updatedCartCount = [...cart?.cartProducts, { 
                        product_id: productId, 
                        product_variant_id: productVId, 
                        qty: qty,
                        selected_color: selectedColor,
                        selected_size: selectedSize 
                    }];
                    dispatch(setCartProducts({ data: updatedCartCount }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                } else {
                    // Update existing product quantity
                    const updatedProducts = cart?.cartProducts?.map(product => {
                        if (product.product_id == productId && product?.product_variant_id == productVId && product?.selected_color === selectedColor && product?.selected_size === selectedSize) {
                            return { 
                                ...product, 
                                qty: qty,
                                selected_color: selectedColor,
                                selected_size: selectedSize 
                            };
                        }
                        return product;
                    });
                    dispatch(setCart({ data: response }));
                    dispatch(setCartProducts({ data: updatedProducts }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                }
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    const removeFromCart = async (productId, variantId) => {
        try {
            const response = await newApi.removeFromCart({ 
                product_id: productId, 
                product_variant_id: variantId,
                selected_color: selectedColor,
                selected_size: selectedSize
            })
            if (response?.status === 1) {
                const updatedProducts = cart?.cartProducts?.filter(product => {
                    // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                    return !(product?.product_id === productId && 
                            product?.product_variant_id === variantId &&
                            product?.selected_color === selectedColor &&
                            product?.selected_size === selectedSize);
                });
                dispatch(setCartSubTotal({ data: response?.sub_total }));
                dispatch(setCartProducts({ data: updatedProducts }));
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    const getProductQuantities = (products) => {
        if (!products || !Array.isArray(products) || products.length === 0) {
            return [];
        }
        return Object.entries(products.reduce((quantities, product) => {
            if (!product || !product.product_id) {
                return quantities;
            }
            const existingQty = quantities[product.product_id] || 0;
            return { ...quantities, [product.product_id]: existingQty + (product.qty || 0) };
        }, {})).map(([productId, qty]) => ({
            product_id: parseInt(productId),
            qty
        }));
    }

    const addToFavorite = async (prdctId) => {
        try {
            if (user?.jwtToken) {
                const res = await newApi.addToFavorite({ product_id: prdctId });
                if (res.status == 1) {
                    toast.success(res.message)
                    dispatch(addFavoriteProductId({ data: prdctId }))
                } else {
                    toast.error(res.message)
                }
            } else {
                toast.error(t("required_login_message_for_wishlist"))
            }

        } catch (error) {
            console.log(error)
        }
    }

    const handleValidateAddNewProduct = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty

        if ((productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty || 0) >= Number(product?.total_allowed_quantity)) {
            toast.error('Oops, Limited Stock Available');
        }
        else if (Number(product.is_unlimited_stock)) {
            addToCart(product.id, product?.variants?.[0].id, 1);
        } else {
            if (selectedVariant?.status) {
                addToCart(product.id, selectedVariant?.id, 1);
            } else {
                toast.error('Oops, Limited Stock Available');
            }
        }

    };

    const handleValidateAddExistingProduct = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty
        if (Number(product.is_unlimited_stock)) {
            if (productQty < Number(product?.total_allowed_quantity)) {
                addToCart(product.id, selectedVariant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty + 1);
            } else {
                toast.error('Apologies, maximum product quantity limit reached!');
            }
        } else {
            if (productQty >= Number(selectedVariant?.stock)) {
                toast.error(t("out_of_stock_message"));
            }
            else if (Number(productQty) >= Number(product.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            } else {
                addToCart(product.id, selectedVariant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty + 1);
            }
        }
    };

    const handleAddNewProductGuest = (productQuantity, product) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty
        if (Number(productQty || 0) < Number(product.total_allowed_quantity)) {
            AddToGuestCart(product, product.id, selectedVariant?.id, 1, 0, "add");
        } else {
            toast.error(t("out_of_stock_message"));
        }
    };

    const AddToGuestCart = (product, productId, productVariantId, Qty, isExisting, flag) => {
        const now = new Date();
        const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
        const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
        const isDiscountActive = selectedVariant?.discounted_price && 
                               selectedVariant?.discounted_price !== 0 && 
                               selectedVariant?.discounted_price < selectedVariant?.price &&
                               startDate && endDate &&
                               now >= startDate && now <= endDate;
        const finalPrice = isDiscountActive ? selectedVariant?.discounted_price : selectedVariant?.price
        if (isExisting) {
            let updatedProducts;
            if (Qty !== 0) {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.map((product) => {

                    if (product?.product_id == productId && product?.product_variant_id == productVariantId) {
                        return { 
                            ...product, 
                            qty: Qty,
                            selected_color: selectedColor,
                            selected_size: selectedSize
                        };
                    } else {
                        return product;
                    }

                });
            } else {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.filter(product =>
                    product?.product_id != productId && product?.product_variant_id != productVariantId
                );
            }

            dispatch(addtoGuestCart({ data: updatedProducts }));

        } else {
            if (flag == "add") {
                dispatch(addGuestCartTotal({ data: finalPrice }));
            } else if (flag == "remove") {
                dispatch(subGuestCartTotal({ data: finalPrice }));
            }
            const productData = { 
                product_id: productId, 
                product_variant_id: productVariantId, 
                qty: Qty, 
                productPrice: finalPrice,
                selected_color: selectedColor,
                selected_size: selectedSize
            };
            dispatch(addtoGuestCart({ data: [...cart?.guestCart, productData] }));
        }
    };

    const handleValidateAddExistingGuestProduct = (productQuantity, product, quantity) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;
        if (Number(product.is_unlimited_stock)) {
            if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            }
            else {
                AddToGuestCart(product, product?.id, selectedVariant?.id, quantity, 1, "add");
            }
        }
        else {
            if (productQty >= Number(selectedVariant?.stock)) {
                toast.error('Oops, Limited Stock Available');
            }
            else if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum cart quantity limit reached');
            }
            else {
                AddToGuestCart(product, product?.id, selectedVariant?.id, quantity, 1, "add");
            }
        }
    };


    const calculateDiscount = (discountPrice, actualPrice) => {
        const difference = actualPrice - discountPrice;
        const actualDiscountPrice = (difference / actualPrice)
        return actualDiscountPrice * 100;
    }

    const handleVariantModal = (product) => {
        if (product?.variants?.length > 1) {
            setShowVariantModal(true)
        }
    }

    // دالة معالجة تغيير المتغير
    const handleVariantSelect = (variant) => {
        setSelectedVariant(variant);
        
        // Reset color and size for new variant
        if (isClothingProduct(variant)) {
            const colors = getVariantColors(variant);
            const sizes = getVariantSizes(variant);
            
            if (colors.length > 0) {
                setSelectedColor(colors[0]);
            } else {
                setSelectedColor(null);
            }
            
            if (sizes.length > 0) {
                setSelectedSize(sizes[0]);
            } else {
                setSelectedSize(null);
            }
        } else {
            setSelectedColor(null);
            setSelectedSize(null);
        }
    }

    // دوال معالجة اختيار اللون والمقاس
    const handleColorSelect = (color) => {
        setSelectedColor(color);
    };

    const handleSizeSelect = (size) => {
        setSelectedSize(size);
    };

    const handleQuantityDecrease = () => {

        if (cart?.isGuest) {
            AddToGuestCart(
                product,
                product?.id,
                selectedVariant?.id,
                cart?.guestCart?.find((prdct) => prdct?.product_variant_id == selectedVariant?.id)?.qty - 1,
                1,
                "remove"
            );
        } else {
            if (cart?.cartProducts?.find((prdct) => prdct?.product_variant_id == selectedVariant?.id).qty == 1) {
                removeFromCart(product?.id, selectedVariant?.id)
            } else {
                addToCart(product.id, selectedVariant.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant?.id)?.qty - 1);
            }
        }
    }

    const handleQuantityIncrease = () => {
        if (cart?.isGuest) {
            const productQuantity = getProductQuantities(cart?.guestCart)
            handleValidateAddExistingGuestProduct(
                productQuantity,
                product,
                cart?.guestCart?.find(prdct => prdct?.product_id == product?.id && prdct?.product_variant_id == selectedVariant?.id)?.qty + 1
            )
        } else {
            const quantity = getProductQuantities(cart?.cartProducts)
            handleValidateAddExistingProduct(quantity, product)
        }
    }

    const handleIntialAddToCart = () => {

        if (cart?.isGuest) {
            const quantity = getProductQuantities(cart?.cartProducts)
            handleAddNewProductGuest(quantity, product)
        } else {
            const quantity = getProductQuantities(cart?.cartProducts)
            handleValidateAddNewProduct(quantity, product)
        }
    }

    const isProductAvailabel = ((product?.variants?.length <= 1 && product?.variants?.[0]?.is_unlimited_stock == 0 && product?.variants?.[0]?.stock == 0) || (selectedVariant?.stock == 0 && selectedVariant?.is_unlimited_stock == 0) || (product?.variants?.length <= 1 && product?.variants?.[0]?.status == 0))


    // دوال استخراج الألوان والمقاسات
    const getVariantColors = (variant) => {
        try {
            if (!variant?.colors) return [];
            const colors = JSON.parse(variant.colors);
            return Array.isArray(colors) ? colors : [];
        } catch (error) {
            return [];
        }
    };
    const getVariantSizes = (variant) => {
        try {
            if (!variant?.size) return [];
            const sizes = JSON.parse(variant.size);
            return Array.isArray(sizes) ? sizes : [];
        } catch (error) {
            return [];
        }
    };
    const isClothingProduct = (variant) => variant?.variant_type === 'clothes';
    const isStandardProduct = (variant) => variant?.variant_type === 'standard';
    
    // دوال الكميات المجانية
    const hasFreeQuantityOffer = (variant) => {
        return variant?.free_quantity && variant?.free_quantity > 0;
    };

    const getFreeQuantityText = (variant) => {
        if (!hasFreeQuantityOffer(variant)) return null;
        return `${variant.free_quantity}`;
    };
    
    const getVariantDisplayName = (variant) => {
        if (isClothingProduct(variant)) {
            const colors = getVariantColors(variant);
            const sizes = getVariantSizes(variant);
            let name = '';
            if (colors.length > 0) name += colors[0];
            if (sizes.length > 0) name += name ? ` - ${sizes[0]}` : sizes[0];
            return name || 'متغير';
        } else if (isStandardProduct(variant)) {
            return `${variant.measurement} ${variant.stock_unit_name || 'وحدة'}`;
        }
        return 'متغير';
    };

    return (
        <div className='horizontal-product-grid '>
            <div className='row' >
                <div className="product-image col-6" >
                    <div className='image-container'>
                        <a className="image" onClick={() => navigate(`/product/${product.slug}`)}>
                            <ImageWithPlaceholder src={selectedVariant?.image_url || product.image_url} alt={product?.slug} />
                        </a>
                        {product?.indicator ?
                            <div className='product-vegen-type'>
                                {product?.indicator == 1 ? <img src={VegIcon} alt="Veg icons" /> : <img src={NonVegIcon} alt="non Veg icons" />}

                            </div>
                            : null}
                        <ul
                            className="product-links">
                            <li onClick={() => addToFavorite(product?.id)}><a data-tip={t("add_wishlist")}>
                                {favoriteProducts.favouriteProductIds && favoriteProducts.favouriteProductIds?.includes(product?.id) ? <BiSolidHeart size={20} /> : <BiHeart size={20} />}
                            </a></li>
                            <li onClick={() => {
                            }}><a data-tip={t("quick_view")}
                                onClick={() => {
                                    setselectedProduct(product)
                                    setShowModal(true)
                                }}
                            ><i className="fa fa-eye fa-1x"></i></a></li>
                        </ul>
                    </div>
                    {(() => {
                        const now = new Date();
                        const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
                        const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
                        const isDiscountActive = selectedVariant?.discounted_price && 
                                               selectedVariant?.discounted_price !== 0 && 
                                               selectedVariant?.discounted_price < selectedVariant?.price &&
                                               startDate && endDate &&
                                               now >= startDate && now <= endDate;

                        if (isDiscountActive) {
                            return <span className="product-discount-label">{calculateDiscount(selectedVariant?.discounted_price, selectedVariant?.price).toFixed(1)}% خصم</span>;
                        }
                        return <></>;
                    })()}
                    
                    {/* الكميات المجانية */}
                    {hasFreeQuantityOffer(selectedVariant) && (
                        <div className="horizontal-free-quantity-badge">
                            <span className="gift-icon">🎁</span>
                            <span className="gift-text">{getFreeQuantityText(selectedVariant)} مجاني</span>
                        </div>
                    )}
                    
                    {/* عداد الخصم */}
                    {discountCountdown && (
                        <div className="horizontal-discount-timer">
                            ⏰ {discountCountdown}
                        </div>
                    )}
                </div>
                <div className="horizontal-product-content col-6">
                    <div className='horizontal-product-head'>
                        <div className='horizontal-product-title mt-5'>
                            <h3 className="title"> {product?.name} </h3>
                            {product?.average_rating > 0 ? <div className='rating-container'>
                                <Rate
                                    disabled
                                    defaultValue={product?.average_rating}
                                    allowHalf={true}
                                    style={{ fontSize: 15 }}
                                    characterRender={(node, { index }) => (
                                        <span className={index + 1 <= product?.average_rating ? "filledStar" : "emptyStar"}>
                                            {index + 1 <= product?.average_rating ? <StarFilled /> : <StarOutlined />}
                                        </span>
                                    )}
                                />
                                <p>({product?.average_rating.toFixed(2)})</p>
                            </div> : null}
                        </div>
                        <div className='horizontal-product-price'>{
                            (() => {
                                const now = new Date();
                                const startDate = selectedVariant?.discount_start_date ? new Date(selectedVariant.discount_start_date) : null;
                                const endDate = selectedVariant?.discount_end_date ? new Date(selectedVariant.discount_end_date) : null;
                                const isDiscountActive = selectedVariant?.discounted_price && 
                                                       selectedVariant?.discounted_price !== 0 && 
                                                       selectedVariant?.discounted_price < selectedVariant?.price &&
                                                       startDate && endDate &&
                                                       now >= startDate && now <= endDate;

                                return (
                                    <div className="price price-saudi">
                                        {isDiscountActive ? selectedVariant?.discounted_price : selectedVariant?.price}
                                        {isDiscountActive > 0 ? isDiscountActive : "" && (
                                            <span className='price-saudi'>
                                                {selectedVariant?.price}
                                            </span>
                                        )}
                                    </div>
                                );
                            })()
                        }</div>
                    </div>
                    {/* متغيرات المنتج */}
                    {product?.variants?.length > 1 && (
                        <div className="horizontal-variant-options">
                            <div className="horizontal-variant-list">
                                {product.variants.map((variant) => (
                                    <button
                                        key={variant.id}
                                        className={`horizontal-variant-option ${selectedVariant?.id === variant.id ? 'selected' : ''}`}
                                        onClick={() => handleVariantSelect(variant)}
                                        title={getVariantDisplayName(variant)}
                                    >
                                        {getVariantDisplayName(variant)}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                    {/* الألوان والمقاسات */}
                    {selectedVariant && isClothingProduct(selectedVariant) && (
                        <div className="horizontal-clothing-variant-options">
                                {/* الألوان */}
                                {getVariantColors(selectedVariant).length > 0 && (
                                    <div className="horizontal-variant-column">
                                        <div className="horizontal-color-options">
                                        {getVariantColors(selectedVariant).map((color, index) => (
                                                <button
                                                    key={index}
                                                className={`horizontal-color-swatch ${selectedColor === color ? 'selected' : ''}`}
                                                    style={{ backgroundColor: color }}
                                                onClick={() => handleColorSelect(color)}
                                                    title={color}
                                                    aria-label={`اختر اللون ${color}`}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {/* المقاسات */}
                                {getVariantSizes(selectedVariant).length > 0 && (
                                    <div className="horizontal-variant-column">
                                        <div className="horizontal-size-options">
                                        {getVariantSizes(selectedVariant).map((size, index) => (
                                                <button
                                                    key={index}
                                                className={`horizontal-size-button ${selectedSize === size ? 'selected' : ''}`}
                                                onClick={() => handleSizeSelect(size)}
                                                >
                                                    {size}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}
                    {
                        isProductAvailabel ? <span className='horizontal-card-variant-out-of-stock '>{t("OutOfStock")} </span> :
                            <div className='horizontal-product-buttons'>
                                {isProductAlreadyAdded ?
                                    <div className='horizontal-cart-count-btn '>
                                        <button onClick={() => { handleQuantityDecrease() }}><FaMinus /></button>
                                        <input value={addedQuantity} disabled min='1' type='number' max={selectedVariant?.stock} />
                                        <button onClick={() => { handleQuantityIncrease() }}><FaPlus /></button>
                                    </div> :
                                    <button className='price-button' onClick={() => { handleIntialAddToCart() }}><FaShoppingCart className='mx-2' size={20} />{t("add_cart")}</button>}
                            </div>
                    }
                </div>
            </div>
            <QuickViewModal selectedProduct={selectedProduct} setselectedProduct={setselectedProduct} showModal={showModal} setShowModal={setShowModal}
                setP_id={setP_id}
                setP_V_id={setP_V_id}
            />
            <ProductVariantModal showVariantModal={showVariantModal} setShowVariantModal={setShowVariantModal} product={product} />
        </div >
    )
}

export default HorizonalProduct